export class Location {
  public PostCode: string;
  public Street: string;
  public City: string;

  constructor(PostCode: string, Street: string, City: string) {
    this.PostCode = PostCode;
    this.Street = Street;
    this.City = City;
  }

  getPostCode(): string {
    return `${this.PostCode}`;
  }

  getAddress(): string {
    return `${this.Street}`;
  }

  getCity(): string {
    return `${this.City}`;
  }

  setPostCode(PostCode:string){
   this.PostCode = PostCode;
  }

  setAddress(Street:string){
    this.Street = Street;
  }

  setCity(City:string){
    this.City = City;
  }

}
